export const ROLE_ASSIGNMENT_RULES = {
  ADMIN: { canAssignTo: ['CH', 'MP', 'ED', 'GM'], scope: 'all' },
  CH: { canAssignTo: ['MP', 'ED', 'GM'], scope: 'all' },
  MP: { canAssignTo: ['ED', 'GM'], scope: 'all' },
  ED: { canAssignTo: ['GM'], scope: 'regional' },
  GM: { canAssignTo: [], scope: 'regional' },
};

export const normalizeRole = (role) => (role || '').toString().trim().toUpperCase();
export const normalizeRegion = (region) => (region || '').toString().trim().toUpperCase();

export const hasAssignmentPrivileges = (user) => {
  const role = normalizeRole(user?.role);
  const rule = ROLE_ASSIGNMENT_RULES[role];
  return !!(rule && Array.isArray(rule.canAssignTo) && rule.canAssignTo.length > 0);
};

export const filterAssignableUsers = (
  allUsers = [],
  assignor = {},
  {
    queryRegion,
    excludeIds = new Set(),
  } = {}
) => {
  if (!assignor) return [];

  const role = normalizeRole(assignor.role);
  const rules = ROLE_ASSIGNMENT_RULES[role];

  if (!rules || !Array.isArray(rules.canAssignTo) || rules.canAssignTo.length === 0) {
    return [];
  }

  const normalizedQueryRegion = normalizeRegion(queryRegion);
  const assignorRegion = normalizeRegion(assignor.region);

  return allUsers.filter((user) => {
    if (!user || excludeIds.has(user._id)) {
      return false;
    }

    if (!user.canBeAssignee) {
      return false;
    }

    if (user.isActive === false) {
      return false;
    }

    const targetRole = normalizeRole(user.role);
    if (!rules.canAssignTo.includes(targetRole)) {
      return false;
    }

    const targetRegion = normalizeRegion(user.region);

    // Users with region 'ALL' should always be included regardless of query region
    if (targetRegion === 'ALL') {
      return true;
    }

    if (rules.scope === 'regional') {
      if (!assignorRegion || !targetRegion) {
        return false;
      }

      if (assignorRegion !== targetRegion) {
        return false;
      }

      if (normalizedQueryRegion && normalizedQueryRegion !== 'ALL' && targetRegion !== normalizedQueryRegion) {
        return false;
      }
    } else if (normalizedQueryRegion && normalizedQueryRegion !== 'ALL') {
      if (!targetRegion || targetRegion !== normalizedQueryRegion) {
        return false;
      }
    }

    return true;
  });
};

export const determineEffectiveRegion = ({
  assignor,
  selectedRegion,
  queryRegion,
}) => {
  const role = normalizeRole(assignor?.role);
  if ((role === 'CH' || role === 'MP') && selectedRegion) {
    return selectedRegion;
  }

  if (selectedRegion) {
    return selectedRegion;
  }

  if (queryRegion) {
    return queryRegion;
  }

  return assignor?.region || null;
};

export const isAssignmentActor = (currentUserId, query) => {
  if (!currentUserId || !query) return false;
  const ownerId = query.raisedBy?._id || query.raisedBy?.id || query.raisedBy;
  const assigneeId = query.assignee?._id || query.assignee?.id || query.assignee;
  const assignorId = query.assignor?._id || query.assignor?.id || query.assignor;
  return currentUserId === ownerId || currentUserId === assigneeId || currentUserId === assignorId;
};

